<div class="bulk-btn">
  <button (click)="openSheet($event)" mat-button>
    <span *ngIf="!isOrderLoading">Contribute &nbsp;<app-currency-icon *ngIf="currency && amount" [currency]="currency"></app-currency-icon><span *ngIf="amount"> {{vars.couponDetails?.payable_amount || amount}}</span></span>
    <div *ngIf="isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
</div>

<ng-template #bulkDonation>
  <div class="wrap-bulk">
    <div class="header">
      <div class="back-btn" (click)="close()" mat-ripple><em class="material-icons">arrow_back_ios_new</em></div>
      <div class="sub-title">Before you go,</div>
      <div class="title">It’d be a big help in saving their lives if you could contribute to them also.</div>
    </div>
    <div *ngIf="campaigns?.length > 0">
      <div class="stories" *ngFor="let item of campaigns">
        <div class="tile">
          <div class="tile-info">
            <div class="time-left">
              <em class="material-icons">schedule</em>
              <span>{{item?.end_date | customDate:'remaingTime':'D-H'}} left</span>
            </div>
            <div class="title">{{item?.title}}</div>
            <div class="required-amt" *ngIf="item?.amount_remaining"><strong><span [innerHTML]="currency | currencyIcon"></span> {{item?.amount_remaining | inrFormat}}</strong> remaining</div>
            <div class="progress">
              <app-progress-bar [amount]="item?.raised?.raised" [goal]="item?.amount_requested" [height]="isMobile ? '6px' : '8px'"></app-progress-bar>
            </div>
          </div>
          <div class="tile-img">
            <img loading="lazy" [attr.data-src]="item?.story_widget?.cdn_path || item?.widget?.cdn_path" appImgFallback [default]="vars.defaultImg" alt="">
            <div class="dnt-btn">
              <button *ngIf="!selected.includes(item.id)" class="btn" (click)="hide(item.id)">
                <em class="material-icons">add</em>
                Contribute
              </button>
            </div>
            <div class="increment-btn" *ngIf="selected.includes(item.id)">
              <button class="plus" (click)="amtchanger('minus', item.id)" mat-ripple>
                <em class="material-icons">remove</em>
              </button>
              <div class="text"><app-currency-icon *ngIf="currency" [currency]="currency" />{{bulkData[item.id].amount}}</div>
              <button class="minus" (click)="amtchanger('plus', item.id)" [class.max]="bulkData[item.id].amount === bulkMinAmount[currency].minamt * 20" mat-ripple>
                <em class="material-icons">add</em>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!campaigns?.length">
      <div class="stories" *ngFor="let item of [1,2]">
        <div class="tile">
          <div class="tile-info">
            <div class="time-left skeleton p-2"></div>
            <div class="title skeleton p-4"></div>
            <div class="required-amt skeleton p-2"></div>
            <div class="progress skeleton p-2"></div>
          </div>
          <div class="tile-img skeleton"></div>
        </div>
      </div>
    </div>
    <div class="submitbtn" [class.active]="isAnySelected">
      <button (click)="submit()" mat-button [disabled]="isOrderLoading ? true : false">
        <span *ngIf="!isOrderLoading">{{btnlabel}}</span>
        <div *ngIf="isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
    </div>
  </div>
</ng-template>
